import { computed, ref, watch } from 'vue';
import { useAuth } from '@/composables/useAuth';

const enabled = ref(false);
const account = ref(null);
const key = (id) => `hr:inbox:development-plans:${id}`;

/** Personal display preference, shared by Inbox and its navigation counters. */
export function useInboxPlanVisibility() {
  const { userId } = useAuth();
  watch(userId, (id) => {
    account.value = id || null;
    try { enabled.value = Boolean(id) && localStorage.getItem(key(id)) === 'true'; }
    catch { enabled.value = false; }
  }, { immediate: true });
  const showDevelopmentPlans = computed({
    get: () => enabled.value,
    set: (value) => {
      enabled.value = Boolean(value);
      if (account.value) {
        try { localStorage.setItem(key(account.value), String(enabled.value)); } catch { /* Session preference still works. */ }
      }
    }
  });
  return { showDevelopmentPlans };
}
